import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withModelInfo } from '../common/ModelInfoContext';
import fetchStandardFeatures from '../api/fetchStandardFeatures';
import fetchInventoryCount from '../api/fetchInventoryCount';
import GMWCContainer from './GMWCContainer';
import Summary from './Summary';
import ErrorBoundary from '../common/ErrorBoundary';
import PrintSummary from './PrintSummary';
import { fetchRegionalIncentives, startOver } from '../store/actions';
import fetchWithCache from '../api/fetchWithCache';
import isVehicleShopperEnabled from '../common/isVehicleShopperEnabled';

class SummaryContainer extends React.Component {
  constructor(props) {
    super(props);
    const {
      isQuantum,
      enableVehicleShopper,
      isLiteRenderMode,
      isFleet,
      isMobile,
      enableInventorySummaryCount,
      isFamilyFirstUS
    } = props.modelInfo;

    const isFleetMobile = isFleet && isMobile;
    const enableInventorySummary = !isFleetMobile && !isLiteRenderMode;
    const enableFetchCount =
      enableInventorySummary && enableInventorySummaryCount;

    this.state = {
      isLoadingStandardFeatures: true,
      standardFeatures: null,
      inventoryCount: null,
      enableInventorySummary,
      enableInventorySummaryCount,
      enableFetchCount,
      isFamilyFirstUS,
      vsParams: '',
      enableVehicleShopper:
        isQuantum &&
        enableVehicleShopper &&
        isVehicleShopperEnabled(props.state.viewInventoryUrlTemplate)
    };
  }

  fetchInventoryCount() {
    const { state, modelInfo } = this.props;
    fetchInventoryCount(modelInfo, state).then(data => {
      this.setState({
        inventoryCount: data.count
      });
    });
  }

  fetchVehicleShopperParams() {
    const { modelInfo, state } = this.props;
    const { styleId, selections, options } = state.config;
    const rpos = selections.rpos
      .filter(id => {
        const option = options[id];
        if (!option) {
          return true;
        }
        return !option.includedInPackage;
      })
      .join(',');
    const url = `${
      modelInfo.vehicleShopperParamsUrl
    }${styleId}?rpoList=${rpos}`;

    return fetchWithCache(url);
  }

  fetchVehicleShopperCount() {
    const { vsParams } = this.state;
    const postalCode = this.props.state.params.postalCode;
    const getCountUrl = this.props.modelInfo.vehicleShopperCountUrl;

    if (!this.state.enableVehicleShopper) {
      return;
    }

    const url = `${getCountUrl}?${vsParams}&postalCode=${postalCode}`;
    return fetchWithCache(url).then(data => {
      this.setState({
        inventoryCount: data.resultsCount
      });
    });
  }

  componentDidMount() {
    const { modelInfo, state, fetchRegionalIncentives } = this.props;
    const styleId = state.config.styleId;
    const { enableFetchCount } = this.state;

    if (modelInfo.country !== 'BR') {
      fetchRegionalIncentives();
    }

    if (enableFetchCount) {
      if (this.state.enableVehicleShopper) {
        this.fetchVehicleShopperParams().then(({ vsParms: vsParams }) => {
          this.setState(
            {
              vsParams: `${vsParams}&radius=${modelInfo.vehicleShopperRadius}`
            },
            () => {
              this.fetchVehicleShopperCount();
            }
          );
        });
      } else {
        this.fetchInventoryCount();
      }
    }

    fetchStandardFeatures({ ...modelInfo, styleId }).then(data => {
      this.setState({
        isLoadingStandardFeatures: false,
        standardFeatures: data
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.state.params.postalCode !== this.props.state.params.postalCode
    ) {
      const { enableFetchCount } = this.state;
      if (enableFetchCount) {
        if (this.state.enableVehicleShopper) {
          this.fetchVehicleShopperCount();
        } else {
          this.fetchInventoryCount();
        }
      }
    }
  }

  onStartOver = () => {
    const { history, startOver, modelInfo } = this.props;
    const step = modelInfo.enableConfigStep ? '/config' : '/trim';
    history.push(step);
    startOver();
  };

  render() {
    const {
      standardFeatures,
      isLoadingStandardFeatures,
      inventoryCount,
      vsParams,
      enableVehicleShopper,
      enableInventorySummary,
      enableInventorySummaryCount
    } = this.state;
    const { state } = this.props;
    return (
      <React.Fragment>
        <GMWCContainer
          config={state.config}
          postalCode={state.params.postalCode}>
          {gmwcState => (
            <Summary
              state={state}
              gmwcState={gmwcState}
              standardFeatures={standardFeatures}
              isLoadingStandardFeatures={isLoadingStandardFeatures}
              onStartOver={this.onStartOver}
              inventoryCount={inventoryCount}
              vsParams={vsParams}
              enableVehicleShopper={enableVehicleShopper}
              enableInventorySummary={enableInventorySummary}
              enableInventorySummaryCount={enableInventorySummaryCount}
            />
          )}
        </GMWCContainer>
        <ErrorBoundary>
          <PrintSummary
            state={state}
            standardFeatures={standardFeatures}
            isLoadingStandardFeatures={isLoadingStandardFeatures}
            isFamilyFirstUS={this.props.modelInfo.isFamilyFirstUS}
          />
        </ErrorBoundary>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    state
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchRegionalIncentives: () => dispatch(fetchRegionalIncentives()),
    startOver: () => dispatch(startOver())
  };
};

export default withRouter(
  withModelInfo(connect(mapStateToProps, mapDispatchToProps)(SummaryContainer))
);
